// angular
import { Component, OnInit } from '@angular/core';
import { AppService } from '../../app.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    template: ''
})

export class MeLanguageSwitchComponent implements OnInit {
    constructor(
        public appService: AppService,
        public router: Router,
        public activatedRoute: ActivatedRoute,
    ) {

    }

    ngOnInit() {
        switch (this.activatedRoute.pathFromRoot[2].snapshot.url[0].path.toLowerCase()) {
            case 'de':
                this.appService.setLanguage('de_CH');
                break;
            case 'en':
                this.appService.setLanguage('en_GB');
                break;
            case 'fr':
                this.appService.setLanguage('fr_FR');
                break;
            case 'it':
                this.appService.setLanguage('it_IT');
                break;
        }
        // redirect to the same path without the first part
        let urlParts = this.activatedRoute.pathFromRoot.slice(3).filter( part => part.snapshot.url.length > 0 ).map( part => part.snapshot.url[0].path );
        if (urlParts.length > 0) {
            this.router.navigate(['me', urlParts.join('/')], { queryParams: this.activatedRoute.snapshot.queryParams });
        } else {
            this.router.navigate(['me'], { queryParams: this.activatedRoute.snapshot.queryParams });
        }
    }
}
